import { GeoJsonLayer } from "@deck.gl/layers";
import mapData from "lib/stores/mapData";
import geojson from "lib/data/.geo.json";
import { easeOutBack } from "lib/helpers/math";
import context from "lib/stores/context";

geojson.features = geojson.features.filter(d => d.geometry);

const getColorByCategory = category => {
  switch (category) {
    case "prevalence":
      return [126, 178, 226];
    case "vulnerability":
      return [102, 171, 171];
    case "gov-response":
      return [255, 133, 115];
    default:
      return [255, 204, 43];
  }
};

const setCountryOutlinesLayer = (activeCountry, activeView) =>
  new GeoJsonLayer({
    id: "country-outlines",
    data: geojson,
    filled: false,
    lineWidthMinPixels: 0.75,
    lineWidthMaxPixels: 4,
    opacity: 1,
    parameters: { depthTest: true },
    lineWidthUnits: "pixels",
    getLineColor: info => (info.properties.ISO_A3 === context.activeCountry ? getColorByCategory(mapData.activeCategory) : [25, 25, 25]),
    getLineWidth: info => (info.properties.ISO_A3 === context.activeCountry ? 4 : 0),
    getPolygon: d => d.polygon,
    updateTriggers: {
      getLineWidth: activeCountry,
      getLineColor: activeCountry + activeView
    },
    transitions: {
      getLineWidth: { duration: 1000, easing: easeOutBack },
      getLineColor: { duration: 1000, easing: easeOutBack }
    }
  });

export { setCountryOutlinesLayer };
